import {Types} from '../Types';
export const validation = (element, index, item) => {

    let all_drop = element;
    let drop = element[index];
    let type = item.type;
    let truefalse = true;

    switch(type) {
        case Types.ONE:
            /* if(all_drop[index - 13])
            {
                all_drop[index - 13].items.map((value, index) => {
                    switch(value.types)
                    {
                        case "left":
                            if(value.item)
                            {
                                truefalse = false;
                            }          
                        break;
                        default:
                        break;
                    }
                    
                });
            }*/
            
            drop.items.map((value, index) => {
                switch(value.types)
                {
                    case 'top':
                        if(value.item)
                        {
                            truefalse = false;
                        }
                    break;
                    default:
                    break;
                }
            });
            if(all_drop[index + 1])
            {
                all_drop[index + 1].items.map((value, index) => {
                    switch(value.types)
                    {
                        case "top":
                            if(value.item)
                            {
                                truefalse = false;
                            }
                        break;
                        default:
                        break;
                    }
                })
            }
            /* if(all_drop[index - 1])
            {
                all_drop[index - 1].items.map((value, index) => {
                    switch(value.types)
                    {
                        case "top":
                        if(value.item)
                        {
                            truefalse = false;
                        }

                        break;
                        default:
                        break;
                    }
                });
            }
            if(all_drop[index + 1])
            {
                all_drop[index + 1].items.map((value, index) => {
                    switch(value.types)
                    {
                        case "top":
                            if(value.item)
                            {
                                truefalse = false;
                            }
                        break;
                        default:
                        break;
                    }
                })
            } */
        break;
        case Types.THREE:
            drop.items.map((value, index) => {
                switch(value.types)
                {
                    case 'top':
                        if(value.item)
                        {
                            truefalse = false;
                        }
                    break;
                    default:
                    break;
                }
            });
            if(all_drop[index - 1])
            {
                all_drop[index - 1].items.map((value, index) => {
                    switch(value.types)
                    {
                        case "top":
                            if(value.item)
                            {
                                if(value.item == Types.ONE)
                                {
                                    truefalse = false;
                                }
                                    
                            }
                        break;
                        default:
                        break;
                    }
                })
            }
        break;
        case Types.TWO:
            drop.items.map((value, index) => {
                switch(value.types)
                {
                    case 'top':
                        if(value.item)
                        {
                            truefalse = false;
                        }
                    break;
                    default:
                    break;
                }
            });
            if(all_drop[index + 1])
            {
                all_drop[index + 1].items.map((value, index) => {
                    switch(value.types)
                    {
                        case "top":
                            if(value.item)
                            {
                                truefalse = false;
                            }
                        break;
                        default:
                        break;
                    }
                })
            }
        break;
        case Types.FOUR:
        drop.items.map((value, index) => {
            switch(value.types)
            {
                case 'top':
                    if(value.item)
                    {
                        truefalse = false;
                    }
                break;
                default:
                break;
            }
        });
        if(all_drop[index - 1])
        {
            all_drop[index - 1].items.map((value, index) => {
                switch(value.types)
                {
                    case "top":
                        if(value.item)
                        {
                            if(value.item == Types.ONE)
                            {
                                truefalse = false;
                            }
                                
                        }
                    break;
                    default:
                    break;
                }
            })
        }
        break;
        default:
        break;
    }
    

    return truefalse;
}

export const validationLeft = (element, index, item) => {
    let all_drop = element;
    let drop = element[index];
    let type = item.type;
    let truefalse = true;

    switch(type)
    {
        case Types.ONE:
            drop.items.map((value, index) => {
                switch(value.types)
                {
                    case "left":
                        if(value.item)
                        {
                            truefalse = false;
                        }
                    break;
                    default:
                    break;
                }
            });
            
            if(all_drop[index - 14])
            {
                all_drop[index - 14].items.map((value, index) => {
                    switch(value.types)
                    {
                        case "left":
                            if(value.items === Types.ONE || value.items === Types.TWO)
                            {
                                if(value.item)
                                {
                                    truefalse = false;
                                }
                            }
                            
                        break;
                        default:
                        break;
                    }
                })
            }
            if(all_drop[index + 14])
            {
                all_drop[index + 14].items.map((value, index) => {
                    switch(value.types)
                    {
                        case "left":
                            if(value.item)
                            {
                                truefalse = false;
                            }
                        break;
                        default:
                        break;
                    }
                })
            }
           /* if(all_drop[index +13])
            {
                drop.items.map((value, index) => {
                    switch(value.types)
                    {
                        case 'top':
                            if(value.item)
                            {
                                truefalse = false;
                            }
                        break;
                        default:
                        break;
                    }
                });
            }
        
            if(all_drop[index + 12])
            {
                all_drop[index + 12].items.map((value, index) => {
                    switch(value.types)
                    {
                        case "top":
                            if(value.item)
                            {
                                if(all_drop[index + 14])
                                {
                                    all_drop[index + 14].items.map((v, i) => {
                                        switch(v.types)
                                        {
                                            case "top":
                                                if(value.item)
                                                {
                                                    truefalse = false;
                                                }
                                            break;
                                            default:
                                            break;
                                        }
                                    })
                                }
                            }
                        break;
                        default:
                        break;
                    }
                })
            }
            /* if(all_drop[index + 13])
            {
                all_drop[index + 13].items.map((value, index) => {
                    switch(value.types)
                    {
                        case "left":
                            if(value.item)
                            {
                                truefalse = false;
                            }
                        break;
                        default:
                        break;
                    }
                })
            }*/
        break;
        case Types.TWO:
            drop.items.map((value, index) => {
                switch(value.types)
                {
                    case "left":
                        if(value.item)
                        {
                            truefalse = false;
                        }
                    break;
                    default:
                    break;
                }
            });
            if(all_drop[index - 14])
            {
                all_drop[index - 14].items.map((value, index) => {
                    switch(value.types)
                    {
                        case "left":
                            if(value.items === Types.ONE || value.items === Types.TWO)
                            {
                                if(value.item)
                                {
                                    truefalse = false;
                                }
                            }
                            
                        break;
                        default:
                        break;
                    }
                })
            }
            if(all_drop[index + 14])
            {
                all_drop[index + 14].items.map((value, index) => {
                    switch(value.types)
                    {
                        case "left":
                            if(value.item)
                            {
                                truefalse = false;
                            }
                        break;
                        default:
                        break;
                    }
                })
            }
        break;
        case Types.THREE:
            drop.items.map((value, index) => {
                switch(value.types)
                {
                    case 'left':
                        if(value.item)
                        {
                            truefalse = false;
                        }
                    break;
                    default:
                    break;
                }
            });
            /* if(all_drop[index - 14])
            {
                all_drop[index - 14].items.map((value, index) => {
                    switch(value.types)
                    {
                        case 'left':
                            if(value.item === Types.ONE)
                            {
                                truefalse = false;
                            }
                        break;
                        default:
                        break;
                    }
                })
            } */ 
        break;
        case Types.FOUR:
        drop.items.map((value, index) => {
            switch(value.types)
            {
                case 'left':
                    if(value.item)
                    {
                        truefalse = false;
                    }
                break;
                default:
                break;
            }
        });
        if(all_drop[index - 14])
        {
            all_drop[index - 14].items.map((value, index) => {
                switch(value.types)
                {
                    case 'left':
                        if(value.item)
                        {
                            if(value.item == Types.ONE)
                            {
                                truefalse = false;
                            }
                            
                        }
                    break;
                    default:
                    break;
                }
            })
        }
        break;
        default:
        break;
    }

    return truefalse;

}



// WEBPACK FOOTER //
// ./src/Services/Global/validation.js